import { env_externalservices } from 'env';

let sentryPromise;

const loadSentry = () => {
  if (env_externalservices !== 'true') return Promise.resolve(null);
  if (!sentryPromise) {
    sentryPromise = import('utils/sentryClient').catch(() => null);
  }
  return sentryPromise;
};

const invoke = (callback) => {
  void loadSentry().then((sentry) => {
    if (sentry) callback(sentry);
  });
};

export const initSentry = (options) => invoke((sentry) => sentry.init(options));

export const setSentryUser = (user) => invoke((sentry) => sentry.setUser(user));

export const captureSentryException = (error) =>
  invoke((sentry) => sentry.captureException(error));
